import React, { useState, useEffect, useMemo } from "react";
import DepositNotice from "../../notice/mobile/DepositNotice";
import { Link, useNavigate } from "react-router-dom";
import Toolbar from "../../navigation/mobile/Toolbar";
import UniversalBack from "../../common/mobile/UniversalBack";
import { Modal } from "react-bootstrap";
import Splash from "../../../splash/Splash";

function MDeposit({ items, promotions, userData , transactionData, hasEWallet, usdtRate}) {
	const [activeItem, setActiveItem] = useState(null);
	const [wapy, setWapy] = useState(false);
	const [activeAmount, setActiveAmount] = useState("");
	const [selectedPromotion, setSelectedPromotion] = useState(null);
	const [isLoading, setIsLoading] = useState(true);
	const [paymentMethod, setPaymentMethod] = useState(null);
	const [paymentSystems, setPaymentSystems] = useState([]);
	const [submitLoading, setSubmitLoading] = useState(false);
	const [showModal, setShowModal] = useState(false);
	const [modalMessage, setModalMessage] = useState("");
	const token = localStorage.getItem("token");
	const amounts = ["2000", "3000", "5000", "10000", "15000", "20000", "25000", "1000", "500", "100"];
	const [selectedOption, setSelectedOption] = useState(null);
	const [pgs, setPgs] = useState([]);
	const navigate = useNavigate();
	
	const [getotherContracts, setotherContracts] = useState([]);
	const [amountRange, setAmountRange] = useState([100, 25000]);
	const [currency, setCurrency] = useState("৳");
	const [presetAmounts, setPresetAmounts] = useState(["100",  "500", "1000", "2000", "3000", "5000", "10000", "15000", "20000", "25000"]);
	const [depositChannel, setDepositChannel] = useState(false);

	const fetchOther = async () => {
        const token = localStorage.getItem('token');
        if (token) {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/api/get/other/phone`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                    },
                });

                if (response.ok) {
                    const data = await response.json();
                    setotherContracts(data.data || []);
                   
                   
                } else {
                    console.error('Failed to fetch user data');
                }
            } catch (error) {
                console.error('Error fetching user data:', error);
            }
        }
    };
		const fetchWay = async () => {
  const token = localStorage.getItem('token');
  if (!token) return;

  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/wpay/check`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/json',
      },
    });

    // 👉 If HTTP status is 200 → WPay active
    if (response.status === 200) {
      setWapy(true);
    } else {
      setWapy(false);
      console.warn("WPay check failed:", response);
    }
  } catch (error) {
    console.error("Error fetching WPay check:", error);
    setWapy(false);
  }
};

	
	useEffect(() => { 
		fetchOther();
		fetchWay();
		let uniquePaymentMethods = [];
		const seenNames = new Set();

		if (items && items.length > 0) {
			items.forEach((item) => {
				if (item.name && !seenNames.has(item.name.toLowerCase())) {
					seenNames.add(item.name.toLowerCase());
					uniquePaymentMethods.push(item);
				}
			});
		}
		
		setPgs(uniquePaymentMethods);
		
	}, []);

	// ✅ Auto-select the first payment method
	useEffect(() => {
		if (items.length > 0) {
			setPaymentMethod(items[0]);
		}
	}, [items]);

	// ✅ Filter out first-deposit promotions that have already been shown (show only once)
	const filteredPromotions = useMemo(() => {
		const shownFirstDepositPromos = JSON.parse(localStorage.getItem('shownFirstDepositPromos') || '[]');
		return promotions.filter(promotion => {
			const isFirstDeposit =
				promotion.name?.toLowerCase().includes('first deposit') ||
				promotion.name?.toLowerCase().includes('1st deposit') ||
				promotion.type === 'first_deposit' ||
				promotion.promotion_type === 'first_deposit';
			if (isFirstDeposit && shownFirstDepositPromos.includes(promotion.id)) {
				return false;
			}
			return true;
		});
	}, [promotions]);

	// ✅ Mark first-deposit promotions as "shown" in localStorage so they don't appear again
	useEffect(() => {
		if (promotions.length > 0) {
			const shownFirstDepositPromos = JSON.parse(localStorage.getItem('shownFirstDepositPromos') || '[]');
			const newShownIds = promotions
				.filter(promotion => {
					const isFirstDeposit =
						promotion.name?.toLowerCase().includes('first deposit') ||
						promotion.name?.toLowerCase().includes('1st deposit') ||
						promotion.type === 'first_deposit' ||
						promotion.promotion_type === 'first_deposit';
					return isFirstDeposit && !shownFirstDepositPromos.includes(promotion.id);
				})
				.map(p => p.id);
			if (newShownIds.length > 0) {
				localStorage.setItem('shownFirstDepositPromos', JSON.stringify([...shownFirstDepositPromos, ...newShownIds]));
			}
		}
	}, [promotions]);

	// ✅ Auto-select the first promotion (from filtered list)
	useEffect(() => {
		if (filteredPromotions.length > 0) {
		setSelectedPromotion(filteredPromotions[0]);
		}
	}, [filteredPromotions]);

	// ✅ Fetch deposit channels when payment method changes
	useEffect(() => {
		console.log("eWa", hasEWallet);
		if (paymentMethod && hasEWallet===false) {
			const fetchPaymentMethodDetails = async () => {
				try {
				const response = await fetch(`${process.env.REACT_APP_API_URL}/api/showpayment-menthod?name=${paymentMethod.name}`, {
					headers: { Authorization: `Bearer ${token}`, 'Origin': window.location.origin },
				});
				const data = await response.json();

					if (data?.success && data.data.length > 0) {
					setPaymentSystems(data.data);
					setSelectedOption(data.data[0]?.id || null); // ✅ Auto-select the first deposit channel
				}
				} catch (error) {
					console.error("Error fetching payment method details:", error);
				} finally {
					setIsLoading(false);
				}
			};
			fetchPaymentMethodDetails();
		}
		if (hasEWallet === true) {
			
			setTimeout(() => {
				let _filtered = [];
				for (let i = 0; i < items.length; i++) {
					// console.log('X',items[i]?.name, paymentMethod?.name);
					if (items[i]?.name.toLowerCase() === paymentMethod?.name.toLowerCase()) {
						_filtered.push(items[i]);
					}
				}
				setPaymentSystems(_filtered);
				setSelectedOption(_filtered[0]?.id || null);
				setIsLoading(false);
			}, 400);
		}
	}, [paymentMethod, token]);


	useEffect(() => { 
		const selectedMethod = items.find((item) => item.id === selectedOption);
		if (selectedMethod?.account_type === 'USDT') {
				setAmountRange([10,200])
				setCurrency('$');
				setPresetAmounts(["10", "20", "30", "50", "100", "150", "200"]);
				setDepositChannel(false);
			} else {
				setAmountRange([100, 25000]);
				setCurrency('৳');
				setPresetAmounts(["100", "500", "1000", "2000", "3000", "5000", "10000", "15000", "20000", "25000"]);
				setDepositChannel(true);
			}
	}, [selectedOption, items]);

	const handleItemClick = (name) => {
		const selectedMethod = items.find((item) => item.name === name);
		if (selectedMethod) {
			setPaymentMethod(selectedMethod);
		}
		setTimeout(() => {
			let _filtered = [];
			for (let i = 0; i < items.length; i++) {
				// console.log('X', items[i]?.name, paymentMethod?.name);
				if (items[i]?.name.toLowerCase() === paymentMethod?.name.toLowerCase()) {
					_filtered.push(items[i]);
				}
			}
			// console.log("Filtered DD", _filtered);
			setPaymentSystems(_filtered);
			setSelectedOption(_filtered[0]?.id || null);
		}, 200);
	};

	const handleSelection = (id) => {
		setSelectedOption(id);
	};

	const handleAmountClick = (amount) => {
		setActiveAmount(amount);
	};

	const handlePromotionChange = (event) => {
		const selectedId = parseInt(event.target.value);
		const selectedPromo = filteredPromotions.find((promo) => promo.id === selectedId);
		setSelectedPromotion(selectedPromo || null);
	};

	const handleSubmit = async () => {
		window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'deposit_button_click',
    category: 'User Deposit',
    action: 'Click',
    label: 'Deposit Button'
  });



		if (transactionData && transactionData.length > 0) {
			for (let trns of transactionData) {
				if (trns.action == "deposit" && trns.key === "0") {
					setModalMessage(`You already have a deposit request pending. Please wait for it to be processed before making another deposit.`);
					setShowModal(true);
					return;
				}
			}
		}
		
		if (!activeAmount) {
			setModalMessage("Please fill in your amount.");
			setShowModal(true);
			return;
		}

		if (!paymentMethod) {
			setModalMessage("Please select a valid payment method.");
			setShowModal(true);
			return;
		}

		const selectedPaymentSystem = paymentSystems.find(item => item.id === selectedOption);
		if (!selectedPaymentSystem) {
			setModalMessage("Please select a Deposit channel.");
			setShowModal(true);
			return;
		}

		try {
			if (hasEWallet) { 
				try {
					const response = await fetch(`${process.env.REACT_APP_API_URL}/api/ewa/request`, {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json',
							'Authorization': `Bearer ${token}`,
							'Origin': window.location.origin,
						},
						body: JSON.stringify({
							amount: activeAmount,
							type: selectedPaymentSystem.account_type,
							provider: paymentMethod.name,
							promotion: selectedPromotion?.id || 0,
						}),
					});
					const data = await response.json();
					
					if (response.ok) {
						if (data?.url) {
							window.location.href = data.url;
							return;
						}
						navigate("/make-payment", {
							state: {
								amount: data?.amount ?? activeAmount,
								payment_icon: selectedPaymentSystem?.icon,
								payment_type: selectedPaymentSystem?.account_type,
								paymentMethodid: paymentMethod?.id,
								paymentMethodName: paymentMethod?.name,
								promotion: selectedPromotion?.id || null,
								transaction: data?.transaction,
								number: data?.number,
								timer: data?.timer ?? 10, 
								message: data?.message
							},
						});
					} else {
						setModalMessage(data?.message || "An error occurred. Please try again.");
						setShowModal(true);
					}
					// } else {
					// }
				} catch (error) { 
					let err = error?.response?.data?.message || "An error occurred. Please try again.";
					setModalMessage(err || "An error occurred. Please try again.");
					console.error("Error fetching e-wallet request:", error);
					setModalMessage("An error occurred. Please try again.");
					setShowModal(true);
				}

			}
			else if (wapy) {
					const baseUrl = `${process.env.REACT_APP_API_URL}/api/payin`;

					
					const params = new URLSearchParams({
						amount: activeAmount,
						method: (paymentMethod?.name || '').toUpperCase(),
					});

					if (selectedPromotion?.id) {
						params.append("promotion", selectedPromotion.id);
					}

					const url = `${baseUrl}?${params.toString()}`;
					

					try {
						const response = await fetch(url, {
						method: "GET",
						headers: {
							"Authorization": `Bearer ${token}`,
							"Accept": "application/json",
						},
						});

						const data = await response.json();
						
						window.open(data[0].data.url, "_blank");
					} catch (error) {
						console.error("Error calling PayIn API:", error);
					}
					}

			else {
				navigate("/make-payment", {
					state: {
						amount: activeAmount,
						payment_icon: selectedPaymentSystem.icon,
						payment_type: selectedPaymentSystem.account_type,
						paymentMethodid: paymentMethod.id,
						paymentMethodName: paymentMethod.name,
						promotion: selectedPromotion?.id || null,
					},
				});
			}
		} catch (error) {
			setModalMessage("An error occurred. Please try again.");
			setShowModal(true);
		} finally {
			setSubmitLoading(false);
		}
	};

	if (isLoading) {
		return (
		<Splash onSplashComplete={() => {
			setIsLoading(false);
			// Force a re-render to ensure all event handlers are properly attached
			setTimeout(() => {
				window.dispatchEvent(new Event('resize'));
			}, 100);
		}}/>
		);
	}

	return (
		<div className="main-router-wrapper">
		<header id="header" className="login player">
			<div className="header-left-btn-group">
			<UniversalBack />
			</div>
			<div className="header-title">Funds</div>
			<div
			className="logo"
			tabIndex={0}
			style={{ backgroundImage: 'url("https://img.j189eb.com/jb/h5/assets/images/logo.png")' }}
			/>
		</header>

		<div className="wrap">
			<div className="content fixed-tab player-content">
			<div className="tab-btn-section tab-btn-wrap">
				<div className="tab-btn tab-btn-bar">
				<div className="line" style={{ width: "50%" }} />
				<div className="btn active">
					<Link className="text-white" to="/deposit">
					<div className="text">Deposit</div>
					</Link>
				</div>
				<div className="btn">
					<Link className="text-white" to="/withdrawal">
					<div className="text">Withdrawal</div>
					</Link>
				</div>
				</div>
			</div>

			<div className="tab-content disable">
				<div className="inner-wrap">
				<div className="inner-box deposit-wallet">
					<div className="player-deposit-wrap">
					<div className="player-deposit-step1">
						{/* Promotion Selector */}
						<div className="option-group select-bar">
						<label>
							<span
							className="item-icon"
							style={{
								backgroundImage:
								'url("https://img.j189eb.com/jb/h5/assets/images/icon-set/icon-selectpromotion.svg")',
							}}
							/>
							<div>Select Promotion</div>
						</label>
						<div className="option-wrap">
							<select
							onChange={handlePromotionChange}
							defaultValue={selectedPromotion?.id || ""}
							>
							{filteredPromotions.map((promotion) => (
								<option key={promotion.id} value={promotion.id}>
								{promotion.name}
								</option>
							))}
							</select>
						</div>
						</div>
						<DepositNotice />

						{/* Payment Method */}
						<div className="menu-box">
						<div className="title">
							<h2>Payment Method</h2>
						</div>
						<div className="select-group checkbox-style">
							<ul className="col3">
							{pgs.map(
								(item) =>
								item.status === "active" && (
									<li
									key={item.id}
										
									className="ng-star-inserted"
									>
									<input
										type="radio"
										name="paymentMethod"
										id={`paymentMethod_${item.id}`}
										onChange={() => handleItemClick(item.name)}
										checked={paymentMethod?.name === item.name}
									/>
									<label htmlFor={`paymentMethod_${item.id}`}>
										<div className="bank ng-star-inserted">
										<img
											alt={item.name}
											src={`${process.env.REACT_APP_API_URL}/storage/${item.icon}`}
											loading="lazy"
										/>
										</div>
										<span>{item.name}</span>
										<div className="tag-rebate-money"><p ><span>+</span>{selectedPromotion?.deposit_bouns ? Math.round(selectedPromotion.deposit_bouns) : 0}
										<span>%</span></p></div>
									</label>
									</li>
								)
							)}
							</ul>
						</div>
						</div>

						{/* Deposit Channel - Only show if depositChannel is true */}				
						{depositChannel && (
							<div  className="deposit-normal ng-tns-c324864554-6 ng-star-inserted">
								<div  className="ng-tns-c324864554-6 ng-trigger ng-trigger-staggerFadeAnimation ng-star-inserted" style={{}}>
								<div  className="menu-box ng-tns-c324864554-6 ng-star-inserted" style={{}}>
									<div  className="title ng-tns-c324864554-6">
									<h2  className="ng-tns-c324864554-6"><span  className="ng-tns-c324864554-6">Deposit Channel</span></h2>
									</div>
									<div  className="select-group checkbox-style checkbox-height-set ng-tns-c324864554-6">
									<ul className="col4 ng-tns-c324864554-6">
									{paymentSystems.map(ps => (
									<React.Fragment key={ps.id}>
										{/* Show CashOut if account_type is Agent */}
										{ps.account_type === "Agent" && (
										<li className="ng-star-inserted">
											<input  type="radio"  onChange={() => {
												handleSelection(ps.id);
												setActiveItem(ps.id);   
											}}
											name="depositSetting" id={`depositSetting_${ps.id}`}
											checked={selectedOption === ps.id} />
											<label htmlFor={`depositSetting_${ps.id}`}>
											<span>CashOut</span>
											<div className="tag-recommond ng-star-inserted">
											<span className="item-icon" style={{ maskImage: `url("https://img.j189eb.com/jb/h5/assets/images/icon-set/icon-recommond.svg?v=1735038087741")` }} />

											</div>
											<span className="item-icon" style={{ maskImage: 'url("https://img.j189eb.com/jb/h5/assets/images/player/select-check.svg?v=1735038087741")' }} />
											</label>
										</li>
											)}
											
										{(ps.account_type === "Merchant" || ps.account_type === "Marchent") && (
										<li className="ng-star-inserted">
											<input  type="radio"  onChange={() => {
												handleSelection(ps.id);
												setActiveItem(ps.id);   
											}}
											name="depositSetting" id={`depositSetting_${ps.id}`}
											checked={selectedOption === ps.id} />
											<label htmlFor={`depositSetting_${ps.id}`}>
											<span>Merchant</span>
											<div className="tag-recommond ng-star-inserted">
											<span className="item-icon" style={{ maskImage: `url("https://img.j189eb.com/jb/h5/assets/images/icon-set/icon-recommond.svg?v=1735038087741")` }} />
											</div>
											<span className="item-icon" style={{ maskImage: 'url("https://img.j189eb.com/jb/h5/assets/images/player/select-check.svg?v=1735038087741")' }} />
											</label>
										</li>
										)}
										
										{/* Show Send Money if account_type is Personal */}
										{ps.account_type === "Personal" && (
										<li className="ng-star-inserted">
											<input type="radio" name="depositSetting" onChange={() => handleSelection(ps.id)} id={`depositSetting_${ps.id}`}
												checked={selectedOption === ps.id} />
											<label htmlFor={`depositSetting_${ps.id}`}>
											<span>Send Money</span>
											<span className="item-icon" style={{ maskImage: 'url("https://img.j189eb.com/jb/h5/assets/images/player/select-check.svg?v=1735038087741")' }} />
											</label>
										</li>
										)}
									</React.Fragment>
									))}
								</ul>
									</div>
								</div>
								</div>
							</div>				
						)}
						{/* End Deposit Channel */}

						{/* Amount Selection */}
						<div className="menu-box active">
						<div className="title">
							<h2>
							Amount <i>{currency} {amountRange[0]} - {currency} {amountRange[1]}</i>
							</h2>
						</div>
						<div className="select-group style-add-amount">
							<ul className="col4">
							{presetAmounts.map((amount) => (
								<li
								key={amount}
								onClick={() => handleAmountClick(amount)}
								>
								<input
									type="radio"
									name="depositAmount"
									id={`depositAmount_${amount}`}
								/>
								<label htmlFor={`depositAmount_${amount}`}>
									<span>{amount}</span>
								</label>
								</li>
							))}
							</ul>
						</div>
						<div className="input-group money">
							<label htmlFor="amount">{currency}</label>
							<div className="inputbox">
								<input
									type="number"
									name="amount"
									className="input text-right"
									value={activeAmount}
									onChange={(e) => setActiveAmount(e.target.value)} 
									onClick={(e) => e.stopPropagation()} 
								/>
							</div>
							{ currency === '$' && <div style={{ fontSize: "14px", marginTop: '10px', textAlign: 'center' }}>1 USDT = {usdtRate} BDT/TK</div>}
						</div> 
						</div>

						{/* Submit Button */}
						<div
						style={{ textAlign: "center" }}
						className="member-content "
						>
						<button
						onClick={handleSubmit}
							className="button">
						Next
						</button>
						</div>
						<Modal show={showModal} onHide={() => setShowModal(false)} centered>
							<Modal.Header closeButton>
								<Modal.Title>Error</Modal.Title>
							</Modal.Header>
							<Modal.Body dangerouslySetInnerHTML={{ __html: modalMessage }}>
							</Modal.Body>
						</Modal>
					</div>
					</div>
				</div>
				</div>
			</div>
			</div>
		</div>
		<Toolbar />
		</div>
	);
}

export default MDeposit;
